import { nullable, struct, union } from 'io-ts/Decoder';

import { Id as FileId } from '../../../file/Id';
import { ParentId } from '../../../file/ParentId';
import { Id as FolderId } from '../../../folder/Id';

export const Params = struct({
	parentId: ParentId,
	folderId: nullable(union(FolderId, FileId)),
});
